if (typeof BSS_B2B != undefined) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.classList.contains("sf__tooltip-item") && item.target.localName === "button") {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}
